import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { SearchBarType } from "@/components/dynamic-form/constants";
import { getSearchConfig } from "@/components/dynamic-form/helper/getSearchConfig";
import { getDataPickerSearchConfig } from "@/components/dynamic-form/helper/getSearchConfigByType";
const searchConfig = getSearchConfig(() => {
  const t = getTranslateNsT("exportList");

  return [
    {
      type: SearchBarType.Select,
      label: t("export_list_type"),
      field: "type",
      props: {
        placeholder: t("user_consume_pick_project_all"),
        dropdownMatchSelectWidth: false,
        options: [
          { label: t("user_consume_pick_project_all"), value: 0 },
          { label: t("header_user_tool_consume_list"), value: 1 },
          { label: t("user_export_list_render_list"), value: 2 },
          { label: t("user_export_render_task_type_13"), value: 13 },
          { label: t("user_export_render_task_type_14"), value: 14 },
          { label: t("user_export_render_task_type_15"), value: 15 },
          { label: t("user_export_render_task_type_16"), value: 16 },
        ],
      },
    },
    {
      type: SearchBarType.DatePicker,
      field: "time",
      label: t("export_date"),
      props: {},
    },
  ];
});

export function useSearchConfig() {
  const dataPickerConfig = getDataPickerSearchConfig(searchConfig, "time");
  if (dataPickerConfig?.props) {
    dataPickerConfig.props.disabledDate = (data) => {
      return data.isAfter(new Date());
    };
  }
  return { searchConfig };
}
